const TIN_BASE = {
  id: 'tin',
  label: 'contractsView-tin',
  type: 'single',
  formatNumber: false,
  order: 2,
  visible: [
    {
      step: 1,
      order: 2,
    },
    {
      step: 2,
      order: 2,
    },
    {
      step: 3,
      order: 2,
    },
  ],
};
const TAE_BASE = {
  id: 'tae',
  label: 'contractsView-tae',
  type: 'single',
  order: 3,
  formatNumber: false,
  visible: [
    {
      step: 1,
      order: 3,
    },
    {
      step: 2,
      order: 3,
    },
    {
      step: 3,
      order: 3,
    },
  ],
};

export const generateTinAndTae = (contractTin, contractTae) => {
  return [{ ...TIN_BASE, ...contractTin }, { ...TAE_BASE, ...contractTae }];
};
